import React from 'react';
import { connect } from 'react-redux';
import { Button, MapPinOutlineIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { getCurrentCity } from "../../../../store/blocks/checkAddress/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _CityChangeButton = function _CityChangeButton(_ref) {
  var className = _ref.className,
    currentCity = _ref.currentCity,
    width = _ref.width;
  var style = {
    background: 'white',
    borderColor: '#dfe0e5',
    justifyContent: 'normal',
    padding: '11px 9px',
    position: 'relative',
    width: width
  };
  var changeCity = function changeCity() {
    var regionsButton = document.querySelector('#toggleButton-regions-desktop');
    if (regionsButton) regionsButton.dispatchEvent(new MouseEvent('click', {
      bubbles: true
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-CityChangeButton"
  }, /*#__PURE__*/React.createElement(Button, {
    extraAttributes: {
      style: style
    },
    onClick: changeCity,
    rightIcon: /*#__PURE__*/React.createElement(MapPinOutlineIcon, {
      className: cx('iconClass'),
      fill: "#fffff",
      size: "s"
    }),
    variant: "tertiary"
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('buttonClass')
  }, currentCity)));
};

// @ts-expect-error TODO: типизировать store
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentCity: getCurrentCity(state)
  };
};
export var CityChangeButton = connect(mapStateToProps)(_CityChangeButton);